import { useContext } from 'react'
import { AICallbacksContext } from './AIGenerationContextDef'

/**
 * Hook to get AI callbacks
 * Returns null if not within a provider (safe for components that may render outside mindmap)
 */
export function useAICallbacks() {
  return useContext(AICallbacksContext)
}
